import { Skeleton } from "primereact/skeleton";
import "./dashboardGraphs.css";

interface KpiCardProps {
  title: string;
  value: string;
  icon?: string;
  color?: string;
  hint?: string;
  // 0..100, renders a thin progress bar under the value
  progress?: number;
  tone?: "default" | "warning" | "danger" | "success";
  loading?: boolean;
  onClick?: () => void;
}

/**
 * Single KPI tile: label, main value, optional hint and progress bar.
 */
export default function KpiCard({
  title,
  value,
  icon,
  color = "#252e3f",
  hint,
  progress,
  tone = "default",
  loading = false,
  onClick,
}: KpiCardProps) {
  return (
    <div
      className={`dg-kpi dg-kpi-${tone}${onClick ? " dg-kpi-clickable" : ""}`}
      style={{ borderTopColor: color }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="dg-kpi-head">
        <span className="dg-kpi-title">{title}</span>
        {icon ? (
          <i className={`pi ${icon} dg-kpi-icon`} style={{ color }} />
        ) : null}
      </div>
      {loading ? (
        <Skeleton width="70%" height="1.8rem" className="mt-2" />
      ) : (
        <span className="dg-kpi-value">{value}</span>
      )}
      {progress !== undefined && !loading ? (
        <div className="dg-kpi-progress">
          <div
            className="dg-kpi-progress-fill"
            style={{
              width: `${Math.max(0, Math.min(100, progress))}%`,
              backgroundColor: color,
            }}
          />
        </div>
      ) : null}
      {hint && !loading ? <span className="dg-kpi-hint">{hint}</span> : null}
    </div>
  );
}
